<template>
   <div class="content" v-if="form.isPassword">
    <!-- <div class="visitBox">
      <div class="app-logo">
        <img src="@/assets/images/mini-logo.png" class="mini-logo" />
        <div class="logo-title">
          <p class="blue-text">BiCube Motiion</p>
          <p class="art-text">虚拟建造</p>
        </div>
      </div>

      <div class="notice">请输入您要访问的预览密码:</div>
      <a-input
        v-model="form.password"
        :style="{ width: '320px', marginBottom: '10px' }"
        allow-clear
        :rules="[{ required: true, message: '密码不能为空' }]"
      />
      <a-button type="primary" @click="handleClick">确认</a-button>
    </div>
    <a-spin v-if="loading" class="pointer-events-dom-spin" tip="正在加载中，请稍后..." dot> </a-spin> -->
  

  <div class="sandPassword" v-if="form.isPassword">
    <div class="sandPassword-image">
      <img src="@/assets/images/Group1321316469.png" alt="" />
    </div>
    <div class="sandPassword-title">请输入密码</div>
    <div class="sandPassword-password">
      <a-input-password
        v-model="form.password"
        allow-clear
        :rules="[{ required: true, message: '密码不能为空' }]"
        placeholder="请输入密码"
        @press-enter="handleClick"
      />
    </div>
    <div v-show="message !== ''" class="sandPassword-message">{{
      message
    }}</div>
    <div class="sandPassword-btn"
      ><a-button class="buttonOk" type="primary" @click="handleClick">确认</a-button>
    </div>
  </div>
</div>
</template>

<script>
import { projectShare } from '../../api/workbench'

export default {
  data() {
    return {
      loading: true,
      releaseStore: {},
      form: {
        shareCode: '',
        isPassword: false,
        password: '',
      },
    }
  },
  mounted() {
    this.form.shareCode = this.$route.query.shareCode
    this.form.isPassword = this.$route.query.isPassword
    if (this.form.shareCode) {
      this.loading = false
    }
    if (!this.form.isPassword) {
      this.handleClick()
    }
    console.log(this.form, 'formform')
  },
  methods: {
    async handleClick() {
      let res = await projectShare({
        shareCode: this.form.shareCode,
        sharePwd: this.form.password,
      })
      console.log(res, 'resres')
      if(res.code == 200){
        const url = `https://iot.ccccltd.cn:30007/release/${res.data.userId}/${res.data.iotPublishCode}?sharePwd=${res.data.iotVisitCode}&token=${res.data.token}`
        // 先写死，云渲染资源不足，新增的分享会渲染失败
        // const url = `https://iot.ccccltd.cn:30007/release/15623543950/6fb7b7f6-7a72-4f57-8a2f-e68ffa418f30?sharePwd=6z6H1kqT&token=${res.data.token}`
        window.location.href = url;
      }
    },
  },
}
</script>

<style lang="less" scoped>
.content {
  background-color: #282a2e;
  color: #ffffff;
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  .visitBox {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .app-logo {
      display: flex;
      align-items: center;
      justify-content: center;
      .mini-logo {
        width: 100px;
        height: 100px;
      }
      .logo-title {
        .blue-text {
          font-size: 1vw;
          font-family: Source Han Sans CN-Medium, Source Han Sans CN;
          color: #00a4ff;
          font-weight: 300;
        }
        .art-text {
          font-size: 1.2vw;
          color: var(--color-white);
          margin-top: -10px;
        }
      }
    }

    .notice {
      color: var(--color-white);
      margin: 10px 0 5px 0;
    }
  }
}
.sandPassword {
  width: 298px;
  height: 254px;
  &-image {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    padding-bottom: 12px;
    img {
      width: 83px;
      height: 116px;
    }
  }
  &-title {
    display: flex;
    justify-content: center;
    font-family: Source Han Sans CN, Source Han Sans CN;
    font-weight: 500;
    font-size: 16px;
    color: #ffffff;
    line-height: 22px;
    text-align: left;
    font-style: normal;
    text-transform: none;
    padding-bottom: 16px;
  }
  &-password {
    width: 100%;
    padding-bottom: 16px;
  }
  &-message {
    font-family: Source Han Sans CN, Source Han Sans CN;
    font-weight: 400;
    font-size: 12px;
    color: #e02e16;
    line-height: 20px;
    text-align: left;
    font-style: normal;
    text-transform: none;
    padding-bottom: 16px;
  }
  &-btn {
    width: 100%;
  }
}
.buttonOk {
  width: 100%;
}
/deep/ .ant-input-password-icon{
  color: rgba(255,255,255,0.7) !important;
}

</style>
